$ = jQuery.noConflict();

$(document).ready(function(){
	if ( $('.logo-tabs').length ) {
		$('.logo-tabs').each(function(){
			const thisRef = $(this);
			const nav = $(this).find('.logo-tabs__nav');
			const slidesContainer = $(this).find('.logo-tabs__slides');
			const navItems = $(this).find('.logo-tabs__nav__toggle');
			const indicator = document.createElement('span');
			indicator.classList.add('logo-tabs__nav__toggle-indicator');
			
			$(this).find('.logo-tabs__nav__toggle.active').get(0).appendChild(indicator);
			
			$(navItems).on('mouseenter', function() {
				const state = Flip.getState(indicator);
				this.appendChild(indicator);
				
				Flip.from(state, {
					absolute: true,
					duration: 0.6,
					ease: 'power3.inOut'
				});
			});
			
			$(nav).on('mouseleave', function() {
				const state = Flip.getState(indicator);
				$(thisRef).find('.logo-tabs__nav__toggle.active').get(0).appendChild(indicator);
				
				Flip.from(state, {
					absolute: true,
					duration: 0.6,
					ease: 'power3.inOut'
				});
			});
			
			let isAnimating = false;
			
			$(navItems).on('click', function() {
				if ( !$(this).hasClass('active') ) {
					if ( !isAnimating ) {
						isAnimating = true;
						$(thisRef).find('.logo-tabs__nav__toggle.active').removeClass('active').attr('aria-expanded', 'false');
						$(this).addClass('active').attr('aria-expanded', 'true');
						
						const activeContainer = $(thisRef).find('.logo-tabs__slide.active');
						const targetContainer = $(thisRef).find( '#' + $(this).attr('aria-controls') );
						
						activeContainer.removeClass('active');
						targetContainer.addClass('active');
						
						const oldHeight = activeContainer.height();
						const newHeight = targetContainer.height();
						
						targetContainer.css({
							display: 'block',
							position: 'absolute',
							top: '0',
							left: '0'
						});
						
						gsap.set(targetContainer.find('.logo-tabs__logo img'), {
							y: '-100%',
							opacity: 0
						});
						
						const timeline = gsap.timeline({
							paused: true,
							repeat: false,
							onComplete: function() {
								targetContainer.css({
									position: 'static'
								});
								
								activeContainer.hide();
								
								gsap.set(activeContainer.find('.logo-tabs__logo img'), {
									clearProps: 'all'
								});
								
								gsap.set(slidesContainer, {
									clearProps: 'all'
								});
								
								isAnimating = false;
								ScrollTrigger.refresh();
							}
						});
						
						activeContainer.find('.logo-tabs__logo img').each(function(index){
							timeline.to(this, {
								y: '100%',
								opacity: 0,
								ease: 'power3.inOut',
								duration: 0.6
							}, index === 0 ? 0 : '-=0.55');
						});
						
						targetContainer.find('.logo-tabs__logo img').each(function(index){
							timeline.to(this, {
								y: '0',
								opacity: 1,
								ease: 'power3.inOut',
								duration: 0.6
							}, ( 0.05 ) * (index + 2) + '');
						});
						
						console.log(oldHeight, newHeight);
						
						if ( oldHeight > newHeight ) {
							timeline.to(slidesContainer, {
								height: newHeight,
								duration: 0.5
							}, '-=0.5');
						} else {
							timeline.to(slidesContainer, {
								height: newHeight,
								duration: timeline.duration()
							}, '0');
						}
						
						timeline.play();
					}
				}
			});
			
			gsap.set($(thisRef).find('.logo-tabs__slide.active').find('.logo-tabs__logo'), {
				y: 16,
				opacity: 0
			});
			
			ScrollTrigger.create({
				trigger: this,
				start: 'top bottom',
				end: 'bottom top',
				onEnter: function() {
					const activeContainer = $(thisRef).find('.logo-tabs__slide.active');
					gsap.to(activeContainer.find('.logo-tabs__logo'), {
						opacity: 1,
						y: 0,
						stagger: {
							each: 0.15,
							grid: [1, 5]
						}
					});
				}, onLeave: function() {
					const activeContainer = $(thisRef).find('.logo-tabs__slide.active');
					gsap.set(activeContainer.find('.logo-tabs__logo'), {
						y: -16,
						opacity: 0
					});
				}, onEnterBack: function() {
					const activeContainer = $(thisRef).find('.logo-tabs__slide.active');
					gsap.to(activeContainer.find('.logo-tabs__logo'), {
						opacity: 1,
						y: 0,
						stagger: {
							each: 0.15,
							grid: [1, 5],
							from: 'end'
						}
					});
				}, onLeaveBack: function() {
					const activeContainer = $(thisRef).find('.logo-tabs__slide.active');
					gsap.set(activeContainer.find('.logo-tabs__logo'), {
						y: 16,
						opacity: 0
					});
				}
			})
		});
	}
});